import { GEOIP_FAILURE, GEOIP_FALLBACK, GEOIP_REQUEST, GEOIP_SUCCESS } from "./geoip-action-types";

const geoIpRequest = () => ({
    type: GEOIP_REQUEST
});

const geoIpSuccess = (locationData) => ({
    type: GEOIP_SUCCESS,
    response: locationData
});

const geoIpFailure = (errorObj) => ({
    type: GEOIP_FAILURE,
    error: errorObj
});

const geoIpFallback = (country) => ({
    type: GEOIP_FALLBACK,
    response: { country }
});

export default {
    geoIpRequest,
    geoIpSuccess,
    geoIpFailure,
    geoIpFallback
};
